import { createRouter, createWebHashHistory } from 'vue-router';
import AppLayout from '@/layout/AppLayout.vue';
import { usePermissions } from '@/composables/usePermissions';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/pages/authentication/Login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/pages/authentication/Register.vue'),
  },

  {
    path: '/',
    redirect: '/projetos',
    component: AppLayout,
    children: [
      {
        path: '/projetos',
        name: 'projects',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/project/Project.vue'),
      },
      {
        path: '/projetos/novo',
        name: 'project-new',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/project/ProjectDetail.vue'),
      },
      {
        path: '/projetos/:id',
        name: 'project-detail',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/project/ProjectDetail.vue'),
      },
      {
        path: '/projetos/visualizar/:id',
        name: 'project-view',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/project/ProjectView.vue'),
      },
      {
        path: '/usuario',
        name: 'usuario',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/usuario/Users.vue'),
      },
      {
        path: '/usuarios/:id',
        name: 'user-view',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/usuario/UserView.vue'),
      },
      {
        path: '/tarefas',
        name: 'tasks',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/task/Task.vue'),
      },
      {
        path: '/tarefas/:id',
        name: 'task-view',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/task/TaskView.vue'),
      },
      {
        path: '/entregaveis',
        name: 'deliverables',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/deliverable/deliverable.vue'),
      },
      {
        path: '/entregaveis/:id',
        name: 'deliverable-view',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/deliverable/DeliverableView.vue'),
      },
      {
        path: '/coordenacao',
        name: 'coordenacao',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/coordenacao/Coordenacao.vue'),
      },
      {
        path: '/agenda-eventos',
        name: 'event-calendar',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/event/EventCalendar.vue'),
      },
      {
        path: '/agenda-eventos/:id',
        name: 'event-view',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/event/EventView.vue'),
      },
      {
        path: '/midia/meios',
        name: 'midia-meios',
        meta: {
          requiresAuth: true,
          permission: 'sistema.midia_gerenciar'
        },
        component: () => import('@/views/pages/midia/Meios.vue'),
      },
      {
        path: '/midia/veiculos',
        name: 'midia-veiculos',
        meta: {
          requiresAuth: true,
          permission: 'sistema.midia_gerenciar'
        },
        component: () => import('@/views/pages/midia/Veiculos.vue'),
      },
      {
        path: '/midia/categorias-cobranca',
        name: 'midia-categorias-cobranca',
        meta: {
          requiresAuth: true,
          permission: 'sistema.midia_gerenciar'
        },
        component: () => import('@/views/pages/midia/CategoriasCobranca.vue'),
      },
      {
        path: '/midia/clientes',
        name: 'midia-clientes',
        meta: {
          requiresAuth: true,
          permission: 'sistema.midia_gerenciar'
        },
        component: () => import('@/views/pages/midia/ClientesMidia.vue'),
      },
      {
        path: '/midia/locais-cobranca',
        name: 'midia-locais-cobranca',
        meta: {
          requiresAuth: true,
          permission: 'sistema.midia_gerenciar'
        },
        component: () => import('@/views/pages/midia/LocaisCobranca.vue'),
      },
      {
        path: '/midia/configuracoes',
        name: 'midia-configuracoes',
        meta: {
          requiresAuth: true,
          permission: 'sistema.midia_gerenciar'
        },
        component: () => import('@/views/pages/midia/ConfiguracoesMidia.vue'),
      },
      {
        path: '/midia/mapas/:mapaId/construir',
        name: 'midia-mapa-construir',
        meta: {
          requiresAuth: true,
          permission: 'sistema.midia_gerenciar'
        },
        component: () => import('@/views/pages/midia/MapaMidiaBuild.vue'),
      },
      {
        path: '/midia/redes',
        name: 'midia-redes',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/midia/ProjectNetworks.vue'),
      },
      {
        path: '/relatorios',
        name: 'relatorios',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/relatorio/Relatorio.vue'),
      },
    ],
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem('tokenAccess');
      if (to.name !== 'login' && !token) {
        next({ name: 'login' });
      } else {
        next();
      }
    },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.beforeEach((to, from, next) => {
  const loggedIn = !!localStorage.getItem('tokenAccess');
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({
      name: 'login'
    });
    return;
  }

  const permission = to.matched.find((record) => record.meta.permission)?.meta.permission;
  if (permission) {
    const { can } = usePermissions();
    if (!can(permission)) {
      next({ path: '/' });
      return;
    }
  }

  next();
});
export default router;
